import { render, staticRenderFns } from "./goods-bills.vue?vue&type=template&id=5ccdd58a&scoped=true&"
import script from "./goods-bills.vue?vue&type=script&lang=js&"
export * from "./goods-bills.vue?vue&type=script&lang=js&"
import style0 from "./goods-bills.vue?vue&type=style&index=0&id=5ccdd58a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccdd58a",
  null
  
)

export default component.exports